import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-wrapper">
      {/* Hero Section */}
      <section className="about-hero">
        <h1>Email Marketing Platform Built for Growing Businesses</h1>
        <p>MailSnappy is an email marketing platform built to help growing businesses create meaningful customer connections and achieve measurable results. Whether you are a startup, ecommerce brand, SaaS company, or digital agency, our platform makes it easy to design professional email campaigns, automate customer journeys, manage subscribers, and track campaign performance from one intuitive dashboard. With AI powered email marketing tools, responsive email templates, advanced automation, and detailed analytics, you can save time while increasing engagement and conversions. Our mission is to make professional email marketing software simple, affordable, and accessible, empowering businesses of every size to grow faster through smarter and more effective email marketing.</p>
        {/* <div className="about-images">
          <img src={aiFallback} alt="Team" />
          <img src={aiFallback} alt="Award event" />
          <img src={aiFallback} alt="Office" />
        </div> */}
      </section>

      {/* Story Section */}
      <section className="about-story">
        <div className="story-content">
          <h2>Every Great Business Starts with One Email</h2>
          <p>
            Every successful business begins with a simple goal to connect with people. What starts as one idea soon becomes a growing audience, new customers, and bigger opportunities. Along the way, many businesses discover that email marketing is one of the most powerful ways to build trust, nurture relationships, and drive long term growth. But creating professional campaigns, managing subscribers, and tracking results should never feel complicated or expensive.
That belief inspired MailSnappy. We built an email marketing platform that removes the complexity so businesses can focus on what truly matters, growing their brand and serving their customers. From AI powered email creation and automation to audience segmentation and campaign analytics, every feature is designed to help you communicate with confidence.
Because your next customer could be just one email away, and we are here to help you send it.
          </p>
          <p>
            We’re committed to saving you money. We’ll never compromise on deliverability, 
            and we’re passionate about providing great service with a personal touch.
          </p>
          <p>
            From self-published authors to food blogging superstars and charities to online stores, 
            we’ve helped over <strong>101,000 organisations</strong> send more than 
            <strong> 49 billion emails</strong>.
          </p>
        </div>

        <div className="story-stats">
          <div className="stat-card">
            <p className="stat-label">Founded in 2015</p>
          </div>
          <div className="stat-card">
            <p className="stat-label">Helped over 101,000 organisations</p>
            <h3>49,152,003,136</h3>
            <p className="stat-sub">emails sent</p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values">
        <div className="value-card">
          <h4>Keeping Email Marketing Simple</h4>
          <p>
            We believe powerful email marketing software should be easy for everyone. MailSnappy removes unnecessary complexity so you can create professional email campaigns, automate your marketing, and grow your business with an intuitive platform designed for speed, simplicity, and better results.
          </p>
        </div>

        <div className="value-card">
          <h4>Helping Businesses Grow</h4>
          <p>
            Our mission is to help businesses build stronger customer relationships through smarter email marketing. From AI powered email creation to automation and campaign analytics, every feature is designed to increase engagement, improve conversions, and support long term business growth.
          </p>
        </div>

        <div className="value-card">
          <h4>Built for Businesses, Not Investors</h4>
          <p>
            MailSnappy is built with one priority, delivering value to our customers. Every feature, improvement, and innovation is focused on making email marketing more reliable, affordable, and effective, helping businesses of every size succeed without unnecessary costs or complexity.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
